import React, { Component } from "react";
import { Container } from "react-bootstrap";

import "./HomeScreen.css";

class HomeScreen extends Component {
	render() {
		return (
			<Container>
				<div className="site-index">
					<div className="jumbotron">
						<h1 className="text-family">Find a Doctor API</h1>
						<p className="lead">Provider Network Tools / Digital Patient Experience</p>
						<p><a className="btn btn-lg btn-success" href="https://app.swaggerhub.com/apis-docs/northwell-fad/northwell-fad-v3/3.0.0">Documentation</a></p>
					</div>
					<div className="body-content">
						<div className="row">
							<div className="col-lg-4">
								<h2>Data Management Layer</h2>
								<p className="text">Data Management Layer (DML) is the place where you can manage clinical focus terms, custom provider groups, and field level overrides</p>
								<p><a className="btn btn-default" href="https://dml.northwell.io">Documentation &raquo;</a></p>
							</div>
							<div className="col-lg-4">
								<h2>Northwell.edu</h2>
								<p className="text"> Explore Northwell.edu and see Find a Doctor in action!</p>
								<p><a className="btn btn-default" href="https://www.northwell.edu/find-care/find-a-doctor">Northwell.edu &raquo;</a></p>
							</div>
						</div>
					</div>
				</div>
			</Container>
		);
	}
}

export default HomeScreen;
